<template>
    <div class="comp-erpsku">
        <TableList v-bind="getTableProps" @on-check-change="handleCheck"></TableList>
        <div class="margin-top-15 text-right" v-if="multiple">
            <Button class="margin-right-15" type="primary" @click="confirm">确认</Button>
            <Button @click="$emit('on-close')">取消</Button>
        </div>
    </div>
</template>

<script>
import TableList from "./tablelist";
import { HttpGetErpSku, HttpGetManageErpSku } from '../../service/base';
export default {
    props: ["isManage", "multiple"],
    components: {
        TableList
    },
    data () {
        return {}
    },
    computed: {
        getTableProps () {
            let widthStyle = "width: 120px;"
            let searchsData = [
                {
                    label: "ERP SKU",
                    tag: 'vInput',
                    key: 'CN_erpSku',
                    show: true,
                    style: widthStyle
                },
                {
                    label: this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                    tag: 'vInput',
                    key: 'CN_erpSkuCode',
                    show: true,
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.CN_name', { defaultValue: '名称(中文)' }),
                    tag: 'vInput',
                    key: 'CN_name',
                    show: true,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.En_name', { defaultValue: '名称(英文)' }),
                    tag: 'vInput',
                    key: 'CN_nameEn',
                    show: true,
                    style: widthStyle
                },
            ];
            if (this.multiple) {
                searchsData.push(
                    {
                        label: "ERP SKU（多条精确查询）",
                        tag: "vTextarea",
                        props: {
                            placeholder: "一行一条",
                            rows: 2
                        },
                        key: "IN_erpSku",
                        show: true,
                    }
                );
            }
            let columns = [
                {
                    title: "No.",
                    type: 'index',
                    width: 60,
                }, 
                {
                    title: "ERP SKU",
                    key: 'erpSku'
                }, 
                {
                    title: this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                    key: 'erpSkuCode'
                }, 
                {
                    title: this.$t('fbb.inbound.CN_name', { defaultValue: '名称(中文)' }),
                    key: 'name'
                },
                {
                    title: this.$t('global.common.En_name', { defaultValue: "名称(英文)" }),
                    key: 'nameEn'
                }
            ];
            let operate = 
            {
                title: this.$t('global.common.actions', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            };
            if (this.multiple) {
                let selection = {
                    type: "selection",
                    width: 60,
                    formName: "erpSku",
                    align: "center"
                };
                columns.unshift(selection);
            }
            else {
                columns.push(operate);
            }
            return {
                Searchs: {
                    show: true,
                    // style: "border:none;",
                    // labelWidth: 'auto',
                    // align: "left",
                },
                ajaxRequest: async (params) => {
                    let ajaxFunction = HttpGetErpSku;
                    if (this.isManage) {
                        ajaxFunction = HttpGetManageErpSku;
                    }
                    return await ajaxFunction(params);
                } ,
                interceptRequest: (params) => {
                    let { search, ...other} = params;
                    let { IN_erpSku, ...otherSearch } = search;
                    if (IN_erpSku) {
                        IN_erpSku = IN_erpSku.split(/\n/);
                    }
                    return {
                        ...other,
                        search: {
                            ...otherSearch,
                            IN_erpSku
                        }
                    };
                    // params.search.EQ_status = 0
                    // params.search.EQ_enable = 1
                    // delete params.rows
                    // delete params.page
                    // return params
                },
                SearchsData: searchsData,
                columns
            }
        },
    },
    methods: {
        handleCheck (checked) {
            console.log(checked);
            this.checked = checked.map(item => {
                return item.erpSku;
            });
        },
        confirm () {
            this.$emit("on-data", this.checked);
        },
    }
}
</script>

<style>

</style>